module.exports = __webpack_public_path__ + "static/media/caret_down_grey.5a43bde0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/caret_down_grey.svg
// module id = 81
// module chunks = 0